import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class HashRouteGuard implements CanActivate {
    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const hashRoutePrefix = '/#/';

        return state.url.startsWith(hashRoutePrefix)
            ? this.router.parseUrl(state.url.replace(hashRoutePrefix, '/'))
            : true;
    }
}
